// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kHnjy","textarea":"styles_textarea__3DrQK"};